import { apiRequest } from "./client";

export function updateProfile(input: {
  firstName?: string;
  lastName?: string;
}): Promise<{ firstName: string | null; lastName: string | null }> {
  return apiRequest("/api/me/profile", {
    method: "PATCH",
    body: input,
    authenticated: true,
  });
}
